/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Item_2_LabelInputs */

const en_wb_management_item_2_label = /** @type {(inputs: Wb_Management_Item_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order #1048:`)
};

const lv_wb_management_item_2_label = /** @type {(inputs: Wb_Management_Item_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījums #1048:`)
};

/**
* | output |
* | --- |
* | "Order #1048:" |
*
* @param {Wb_Management_Item_2_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_item_2_label = /** @type {((inputs?: Wb_Management_Item_2_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Item_2_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_item_2_label(inputs)
	return en_wb_management_item_2_label(inputs)
});